import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';

import 'css/main.css';
import 'utils/chunkErrorHandler';
import { initCacheManagement } from 'utils/cacheBusting';

import { App } from 'app';
import { store } from 'core/store/configureStore';
import { ChunkErrorBoundary } from 'app/components/ChunkErrorBoundary';
import { isTesting } from 'utils/env';
import { reloadForNewBuild } from 'utils/lazyImport';

initCacheManagement();

// Vite fires this when a chunk's preloaded deps/CSS fail (typically a stale tab after a deploy).
// Reload to pick up the new build; preventDefault stops Vite rethrowing if we did.
window.addEventListener('vite:preloadError', event => {
  if (reloadForNewBuild()) event.preventDefault();
});

// Freezes animation for deterministic screenshots. See src/css/main.css.
if (isTesting()) document.documentElement.setAttribute('data-testing', '');

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

const root = createRoot(MOUNT_NODE);

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <ChunkErrorBoundary>
        <App />
      </ChunkErrorBoundary>
    </HelmetProvider>
  </Provider>,
);
